import {createSlice} from "@reduxjs/toolkit";

interface LoadingState {
  isLoading: boolean;
  loadingTasks: string[];
  completedTasks: string[];
}

const initialState: LoadingState = {
  isLoading: false,
  loadingTasks: [],
  completedTasks: [],
};

export const loadingSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader: (state: any) => {
      state.isLoading = true;
    },
    hideLoader: (state: any) => {
      state.isLoading = false;
    },
    startLoadingTask: (state: any, action: { payload: string }) => {
      const taskId = action.payload;
      if (!state.loadingTasks.includes(taskId)) {
        state.loadingTasks.push(taskId);
      }
      state.completedTasks = state.completedTasks.filter(id => id !== taskId);
      state.isLoading = state.loadingTasks.length > 0;
    },
    completeLoadingTask: (state: any, action: { payload: string }) => {
      const taskId = action.payload;
      state.loadingTasks = state.loadingTasks.filter(id => id !== taskId);
      if (!state.completedTasks.includes(taskId)) {
        state.completedTasks.push(taskId);
      }
      state.isLoading = state.loadingTasks.length > 0;
    },
    resetLoadingState: (state: any) => {
      state.isLoading = false;
      state.loadingTasks = [];
      state.completedTasks = [];
    },
  },
});

export const selectLoaderValue = (state: any) => {
  return state.loader.isLoading;
};

export const selectLoadingTasks = (state: any) => {
  return state.loader.loadingTasks;
};

export const selectCompletedTasks = (state: any) => {
  return state.loader.completedTasks;
};

export const selectIsTaskLoading = (taskId: string) => (state: any) => {
  return state.loader.loadingTasks.includes(taskId);
};

export const selectIsTaskCompleted = (taskId: string) => (state: any) => {
  return state.loader.completedTasks.includes(taskId);
};

export const {showLoader, hideLoader, startLoadingTask, completeLoadingTask, resetLoadingState} = loadingSlice.actions;
export default loadingSlice.reducer;
